import type { PredictorConfig } from "../engine/config";
import type { IsoDate } from "../engine/dates";
import type { Grinder } from "../engine/model";
import { learnSlope, withLearnedSlope, type LearnedSlope } from "../engine/slopeLearning";
import type { Repositories } from "../storage/repositories";
import { activeShots } from "./calibration";

/**
 * The grinder's learned slope from every bean's shots on it since its last recalibration (so recalibrating resets
 * it), and the grinder the predictor should see with that slope in place of the seed.
 */
export async function learnedSlopeFor(repos: Repositories, g: Grinder, today: IsoDate, cfg: PredictorConfig): Promise<LearnedSlope> {
  const beans = [];
  for (const bean of await repos.beans.findAll()) {
    if (bean.id === null || g.id === null) continue;
    const shots = activeShots(await repos.shots.findByBeanAndGrinder(bean.id, g.id), g);
    if (shots.length > 0) beans.push({ bean, shots });
  }
  return learnSlope(g, beans, today, cfg);
}

export async function effectiveGrinder(repos: Repositories, g: Grinder, today: IsoDate, cfg: PredictorConfig): Promise<Grinder> {
  return withLearnedSlope(g, await learnedSlopeFor(repos, g, today, cfg));
}
